import { Navigate, Route, Routes } from 'react-router';
import { RequiredPermission } from '../authentication/RequiredPermission';

import {
  AccionesPersonal,
  AccionesPersonalAgregar,
  AccionesPersonalDetalle,
  AccionesReingreso,
  AccionesReingresoAgregar,
  AccionesReingresoDetalle,
  ReclutamientoSeleccion,
  ReclutamientoSeleccionAgregar,
  ReclutamientoSeleccionDetalle,
  SolicitudEquipo,
} from '../pages/Acciones';

export const RutasAcciones = () => {
  return (
    <Routes>
      <Route element={<RequiredPermission permission={['ROLE_VER_ACCIONES', 'ROLE_ADMIN']} />}>
        <Route path="/personal" element={<AccionesPersonal />} />
        <Route path="/personal/detalle/:accionId" element={<AccionesPersonalDetalle />} />

        <Route path="/reingreso" element={<AccionesReingreso />} />
        <Route path="/reingreso/detalle/:accionId" element={<AccionesReingresoDetalle />} />
      </Route>

      <Route element={<RequiredPermission permission={['ROLE_PERSONAL_ACCIONES', 'ROLE_ADMIN']} />}>
        <Route path="/personal/agregar" element={<AccionesPersonalAgregar />} />

        <Route path="/reingreso/agregar" element={<AccionesReingresoAgregar />} />
      </Route>

      <Route element={<RequiredPermission permission={['ROLE_RECLUTAMIENTO_ACCIONES', 'ROLE_ADMIN']} />}>
        <Route path="/reclutamiento/agregar" element={<ReclutamientoSeleccionAgregar />} />

        <Route path="/reingreso/agregar" element={<AccionesReingresoAgregar />} />
      </Route>

      <Route element={<RequiredPermission permission={['ROLE_VER_ACCIONES', 'ROLE_ADMIN']} />}>
        <Route path="/reclutamiento" element={<ReclutamientoSeleccion />} />
        <Route path="/reclutamiento/detalle/:accionId" element={<ReclutamientoSeleccionDetalle />} />

        <Route path="/reingreso" element={<AccionesReingreso />} />
        <Route path="/reingreso/detalle/:accionId" element={<AccionesReingresoDetalle />} />
        <Route path="/solicitud_equipos" element={<SolicitudEquipo />} />
      </Route>

      <Route path="/*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
